module.exports = __webpack_public_path__ + "img/tabbed-vehicle-rows-mitsu.87df75ad.png";